import { CALL_API, Schemas } from '../common/middleware/api';
import { reset, setSubmitSucceeded } from 'redux-form';
import globalize from '../common/services/globalize';
import analyticsTracker from '../common/services/analyticsTracker';
import { fetchMedicalInformation } from './children/actions';
import moment from 'moment';

export const PARENT_FETCH_REQUEST = 'PARENT_GET_REQUEST';
export const PARENT_FETCH_SUCCESS = 'PARENT_GET_SUCCESS';
export const PARENT_FETCH_FAILURE = 'PARENT_GET_FAILURE';

export const CHILD_CREATE_REQUEST = 'CHILD_CREATE_REQUEST';
export const CHILD_CREATE_SUCCESS = 'CHILD_CREATE_SUCCESS';
export const CHILD_CREATE_FAILURE = 'CHILD_CREATE_FAILURE';

export const CHILD_UPDATE_REQUEST = 'CHILD_UPDATE_REQUEST';
export const CHILD_UPDATE_SUCCESS = 'CHILD_UPDATE_SUCCESS';
export const CHILD_UPDATE_FAILURE = 'CHILD_UPDATE_FAILURE';

export const CHILD_DELETE_REQUEST = 'CHILD_DELETE_REQUEST';
export const CHILD_DELETE_SUCCESS = 'CHILD_DELETE_SUCCESS';
export const CHILD_DELETE_FAILURE = 'CHILD_DELETE_FAILURE';

export const CANCEL_LESSON_REQUEST = 'CANCEL_LESSON_REQUEST';
export const CANCEL_LESSON_SUCCESS = 'CANCEL_LESSON_SUCCESS';
export const CANCEL_LESSON_FAILURE = 'CANCEL_LESSON_FAILURE';

export const CANCEL_WORKSHOP_SESSION_REQUEST = 'CANCEL_WORKSHOP_SESSION_REQUEST';
export const CANCEL_WORKSHOP_SESSION_SUCCESS = 'CANCEL_WORKSHOP_SESSION_SUCCESS';
export const CANCEL_WORKSHOP_SESSION_FAILURE = 'CANCEL_WORKSHOP_SESSION_FAILURE';

export const CHILDREN_GRADES_REQUEST = 'CHILDREN_GRADES_REQUEST';
export const CHILDREN_GRADES_SUCCESS = 'CHILDREN_GRADES_SUCCESS';
export const CHILDREN_GRADES_FAILURE = 'CHILDREN_GRADES_FAILURE';

export const CENTER_UPDATE_REQUEST = 'CENTER_UPDATE_REQUEST';
export const CENTER_UPDATE_SUCCESS = 'CENTER_UPDATE_SUCCESS';
export const CENTER_UPDATE_FAILURE = 'CENTER_UPDATE_FAILURE';

export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_FAILURE = 'PROFILE_UPDATE_FAILURE';

export const PASSWORD_UPDATE_REQUEST = 'PASSWORD_UPDATE_REQUEST';
export const PASSWORD_UPDATE_SUCCESS = 'PASSWORD_UPDATE_SUCCESS';
export const PASSWORD_UPDATE_FAILURE = 'PASSWORD_UPDATE_FAILURE';

export const fetchCurrentParent = () => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [PARENT_FETCH_REQUEST, PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE],
			endpoint: `api/parents/current`,
			onSuccess: (response) => {
				const franchisor = getState().configuration.franchisor;

				//analyticsTracker.updateAdvancedMatching(response);
				changeDefaultTimeZone(franchisor.enableUserTimeZone, response.timeZone);

				if (franchisor.requireMedicalInformation) {
					response.children.forEach(child => {
						dispatch(fetchMedicalInformation(child.id));
					});
				}
			}
		}
	});
};

const changeDefaultTimeZone = (enableUserTimeZone, userTimeZone) => {
	if (enableUserTimeZone && userTimeZone) {
		globalize.setDefaultTimeZone(userTimeZone);
	}
}

const clearTimeFromDateOfBirth = (child) => {
	const dateOfBirth = child.dateOfBirth;
	if (dateOfBirth) {
		child.dateOfBirth = moment(dateOfBirth).format('YYYY-MM-DD')
	}
	return child;
}

export const createChild = (child, history, onSuccess) => ({
	[CALL_API]: {
		types: [CHILD_CREATE_REQUEST, CHILD_CREATE_SUCCESS, CHILD_CREATE_FAILURE],
		endpoint: 'api/children',
		method: 'POST',
		request: clearTimeFromDateOfBirth(child),
		form: 'child',
		transition: history ? {
			history,
			success: {
				push: true,
				path: 'center'		// relative to '/booking/' or '/individual-consultation/booking/'
			}
		} : null,
		onSuccess
	}
});

export const updateChild = (id, child, history) => ({
	[CALL_API]: {
		types: [CHILD_UPDATE_REQUEST, CHILD_UPDATE_SUCCESS, CHILD_UPDATE_FAILURE],
		endpoint: `api/children/${id}`,
		method: 'PUT',
		request: clearTimeFromDateOfBirth(child),
		form: 'child',
		transition: {
			history,
			success: {
				push: true,
				path: '/children'
			}
		}
	}
});

export const deleteChild = id => ({
	[CALL_API]: {
		types: [CHILD_DELETE_REQUEST, CHILD_DELETE_SUCCESS, CHILD_DELETE_FAILURE],
		endpoint: `api/children/${id}`,
		method: 'DELETE'
	}
});

export const cancelLesson = (lessonId, onSuccess) => ({
	[CALL_API]: {
		types: [CANCEL_LESSON_REQUEST, CANCEL_LESSON_SUCCESS, CANCEL_LESSON_FAILURE],
		endpoint: `api/childLessons/cancel/${lessonId}`,
		method: 'PUT',
		schema: Schemas.CHILD_LESSON,
		onSuccess
	}
});

export const cancelWorkshopSession = (sessionId, onSuccess) => ({
	[CALL_API]: {
		types: [CANCEL_WORKSHOP_SESSION_REQUEST, CANCEL_WORKSHOP_SESSION_SUCCESS, CANCEL_WORKSHOP_SESSION_FAILURE],
		endpoint: `api/childWorkshopSessions/cancel/${sessionId}`,
		method: 'PUT',
		schema: Schemas.CHILD_WORKSHOP_SESSION,
		onSuccess
	}
});

export const loadAgeAppropriateGradesByCenterAndTerm = (centerId, termId) => (dispatch, getState) => {
	if (getAgeAppropriateGradesByCenterAndTerm(getState().parent, centerId, termId)) {
		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [CHILDREN_GRADES_REQUEST, CHILDREN_GRADES_SUCCESS, CHILDREN_GRADES_FAILURE],
			endpoint: `api/parents/current/childrenGrades`,
			request: { centerId, termId }
		},
		centerId,
		termId
	});
};

export const updateSelectedCenter = (centerId, history, continueToBooking) => (dispatch, getState) => {
	// do not update if center is not changed
	if (getState().parent.centerId === centerId) {
		if (continueToBooking) {
			history.push('class');	// relative to "/booking/" or "/individual-consultation/booking/"
		}

		return null;
	}

	dispatch({
		[CALL_API]: {
			types: [CENTER_UPDATE_REQUEST, CENTER_UPDATE_SUCCESS, CENTER_UPDATE_FAILURE],
			endpoint: `api/parents/current/center`,
			method: 'PUT',
			request: { centerId },
			transition: {
				history,
				success: {
					push: true,
					path: () => {
						return continueToBooking ? 'class' : '';	// relative to "/booking/" or "/individual-consultation/booking/"					
					}
				}
			}
		}
	});
};

export const updateProfile = (parent) => (dispatch, getState) => {
	dispatch({
		[CALL_API]: {
			types: [PROFILE_UPDATE_REQUEST, PROFILE_UPDATE_SUCCESS, PROFILE_UPDATE_FAILURE],
			endpoint: `api/parents/current`,
			method: 'PUT',
			request: parent,
			form: 'parent',
			onSuccess: (response) => {
				changeDefaultTimeZone(getState().configuration.franchisor.enableUserTimeZone, response.timeZone);
			}
		}
	});
};

export const changePassword = (credentials) => dispatch => {
	dispatch({
		[CALL_API]: {
			types: [PASSWORD_UPDATE_REQUEST, PASSWORD_UPDATE_SUCCESS, PASSWORD_UPDATE_FAILURE],
			endpoint: `api/changePassword`,
			method: 'PUT',
			request: credentials,
			form: 'changePassword',
			onSuccess: () => {
				dispatch(reset('changePassword'));
				dispatch(setSubmitSucceeded('changePassword'));
			}
		}
	});
};

export const getAgeAppropriateGradesByCenterAndTerm = (parent, centerId, termId) => {
	return parent && parent.childrenGrades[`${centerId}:${termId}`];
};

export const getAgeAppropriateGradesByChild = (parent, centerId, termId, childId) => {
	const gradesByCenterAndTerm = getAgeAppropriateGradesByCenterAndTerm(parent, centerId, termId);
	const childGrades = gradesByCenterAndTerm && gradesByCenterAndTerm.find(x => x.childId === childId);
	return childGrades && childGrades.ageAppropriateGradeIds;
};